<template>
    <div>

        <div class="row head">
            <div class="col col-100">Status van het systeem</div>
        </div>
        <div class="row row-first setting system">
            <div class="col col-80">
                <span class="row__title">Bellen</span>
            </div>
            <div class="col col-20">
<!--                <span class="status" v-bind:class="'status--' + status[Math.floor(Math.random() * status.length)]"></span>-->
                <span class="status status--3"></span>
            </div>
        </div>
        <div class="row row-last setting system">
            <div class="col col-80">
                <span class="row__title">Gegevens beheren</span>
            </div>
            <div class="col col-20">
<!--                <span class="status" v-bind:class="'status--' + status[Math.floor(Math.random() * status.length)]"></span>-->
                <span class="status status--3"></span>
            </div>
        </div>
        <div class="row explanation">
            <div class="motd" v-if="motd.enabled == 1" v-bind:class="{warning: motd.type == 'warning', alert: motd.type == 'alert'}">
                <div class="motd-title" v-if="motd.type == 'alert'">Belangrijke waarschuwing</div>
                <div class="motd-title" v-if="motd.type == 'warning'">Waarschuwing</div>
                {{ motd.message }}
            </div>
        </div>

        <div class="row spacer" v-if="$root.app.platform == 'android'">&nbsp;</div>

        <div class="row head">
            <div class="col col-100">Helpcentrum</div>
        </div>
<!--        <div class="row setting has-subitem">
            <div class="col col-100">
                <a v-bind:href="'https://www.dubline.nl/veelgestelde-vragen/'+$root.app.platform" target="_blank">
                    <span class="row__title">Veelgestelde vragen</span>
                </a>
            </div>
        </div>-->
        <div class="row row-single setting">
            <div class="col col-100" v-if="$root.app.platform == 'android'">
                <span class="row__title">Klantenservice</span><br>
                <span v-if="support" class="row__subtitle">Geopend</span>
                <span v-else class="row__subtitle">Gesloten</span>
            </div>
            <div class="col col-70" v-if="$root.app.platform == 'ios'">
                <span class="row__title">Klantenservice</span>
            </div>
            <div class="col col-30" v-if="$root.app.platform == 'ios'">
                <span v-if="support" class="row__subtitle">Geopend</span>
                <span v-else class="row__subtitle">Gesloten</span>
            </div>
        </div>

        <div class="row spacer">&nbsp;</div>

        <div class="row head">
            <div class="col col-100">Support tickets</div>
        </div>
        <div class="row row-single setting has-subitem">
            <div class="col col-100" @click="create">
                <span class="row__title">Nieuwe vraag stellen</span>
            </div>
        </div>

        <div class="row setting has-subitem ticket-preview" v-for="(item, index) in tickets" v-show="item.typeId != 4" v-bind:class="{'row-last': tickets.length - 1 === index }">

            <router-link :to="'/feedback/ticket/'+item.id">
                <div class="col-status">
                    <span class="status" v-bind:class="'status--'+item.statusId"></span>
                </div>
                <div class="col col-info">
                    <div class="row__title">
                        {{ item.subject }} </br><span class="ticket-preview__time">{{ item.creationTime }}</span>
                        <span class="new-messages" v-if="item.newMessages">{{ item.newMessages }}</span>
                    </div>
<!--                    <div class="small">{{ item.message }}</div>-->
                </div>
            </router-link>
        </div>
        <div class="row spacer" v-if="$root.app.platform == 'ios'">&nbsp;</div>

    </div>
</template>

<script>
    export default {
    name: 'Feedback',
        data () {

            return {
                motd: [],
                tickets: [],
                support: []
            }
        },

        mounted(){

        },

        created(){

            this.$api.get('/tickets')
            .then(response => {

                this.motd = response.data.motd;
                this.tickets = response.data.tickets;
                this.support = response.support.available
            })
            .catch(e => {

            })
        },

        methods:{
            create(){

                this.$router.push({path: '/feedback/create'});
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Tickets.vue